import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LocalStorageService } from '../../../../pages/user/services/local-storage.service';
import { BaseMenuItemComponent } from '../base-menu-item.component';
import { SubmenuConfiguracoesPermissionsEnum } from '../enums/menu-permissions.enum';
import { MenuItemChild } from '../models/menu-item-child.model';
import { MenuUtilsService } from '../services/menu-utils.service';
import { MenuSharedService } from '../services/menu.shared.service';

@Component({
  selector: 'config-menu-item',
  templateUrl: '../templates/menu-item.html',
  styleUrls: ['../scss/menu-item.scss'],
})
export class ConfigMenuItem extends BaseMenuItemComponent {
  @Input('show-children') override showChildren: boolean;
  @Output() onClickSelect = new EventEmitter<any>();
  @Output() onClickItem = new EventEmitter<void>();
  isMobile: boolean = false;
  menuCollapsed: boolean;

  constructor(
    menuSharedService: MenuSharedService,
    menuUtilsService: MenuUtilsService,
    private localStorage: LocalStorageService
  ) {
    const referral = (localStorage.get('referral') || '').toLowerCase();
    const isIclinic = referral === 'iclinic';

    const children: MenuItemChild[] = [
      new MenuItemChild(
        'Vendedores',
        '/pages/dados-cadastrais/particular/list',
        false,
        menuUtilsService.userHavePermission(
          SubmenuConfiguracoesPermissionsEnum.VENDEDORES
        )
      ),
      new MenuItemChild(
        'Meu time',
        '/pages/permissionamento/list',
        false,
        menuUtilsService.userHavePermission(
          SubmenuConfiguracoesPermissionsEnum.MEU_TIME
        )
      ),
      ...(isIclinic ? [] : [new MenuItemChild('Meus Terminais', '/pages/terminal', false, true)]),
      new MenuItemChild('Alterar senha', '/change-password', false, true),
    ];

    super(
      'Configurações',
      'configuracoes',
      children,
      `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.5002 10C17.5002 9.77 17.4902 9.55 17.4702 9.32L19.3302 7.91C19.7302 7.61 19.8402 7.05 19.5902 6.61L17.7202 3.38C17.4702 2.94 16.9302 2.76 16.4702 2.96L14.3202 3.87C13.9502 3.61 13.5602 3.38 13.1502 3.19L12.8602 0.88C12.8002 0.38 12.3702 0 11.8702 0H8.14015C7.63015 0 7.20015 0.38 7.14015 0.88L6.85015 3.19C6.44015 3.38 6.05015 3.61 5.68015 3.87L3.53015 2.96C3.07015 2.76 2.53015 2.94 2.28015 3.38L0.410153 6.62C0.160153 7.06 0.270153 7.61 0.670153 7.92L2.53015 9.33C2.51015 9.55 2.50015 9.77 2.50015 10C2.50015 10.23 2.51015 10.45 2.53015 10.68L0.670153 12.09C0.270153 12.39 0.160153 12.95 0.410153 13.39L2.28015 16.62C2.53015 17.06 3.07015 17.24 3.53015 17.04L5.68015 16.13C6.05015 16.39 6.44015 16.62 6.85015 16.81L7.14015 19.12C7.20015 19.62 7.63015 20 8.13015 20H11.8602C12.3602 20 12.7902 19.62 12.8502 19.12L13.1402 16.81C13.5502 16.62 13.9402 16.39 14.3102 16.13L16.4602 17.04C16.9202 17.24 17.4602 17.06 17.7102 16.62L19.5802 13.39C19.8302 12.95 19.7202 12.4 19.3202 12.09L17.4602 10.68C17.4902 10.45 17.5002 10.23 17.5002 10ZM10.0402 13.5C8.11015 13.5 6.54015 11.93 6.54015 10C6.54015 8.07 8.11015 6.5 10.0402 6.5C11.9702 6.5 13.5402 8.07 13.5402 10C13.5402 11.93 11.9702 13.5 10.0402 13.5Z" fill="#90CAF9"/>
      </svg>`,
      false,
      false,
      '0px',
      menuSharedService,
      menuUtilsService
    );

    this.menuSharedService.getSubItemsOf().subscribe((title) => {
      if (title === this.title && !this.showChildren) {
        this.showChildren = true;
        this.heightWhenShowingChildren = menuUtilsService.calculateSubmenuHeight(
          this.children
        );
      } else {
        this.showChildren = false;
        this.heightWhenShowingChildren = '0px';
      }
    });
  }

  async ngOnInit() {
    if (window.innerWidth <= 500 || screen.width <= 500) {
      this.isMobile = true;
    }

    this.menuSharedService.getMenuCollapsed().subscribe((menuCollapsed) => {
      this.menuCollapsed = menuCollapsed;
      this.heightWhenShowingChildren =
        menuCollapsed || this.isMobile ? '0px' : this.heightWhenShowingChildren;

      if (this.menuCollapsed && this.showChildren) {
        this.showChildren = false;
      }
    });
  }

  override toggleItemChildren() {
    super.toggleItemChildren();
    this.onClickSelect.emit({ title: this.title, children: this.children });
    this.isMobile = window.innerWidth <= 500 || screen.width <= 500 ? true : false;
  }

  override menuItemClicked() {
    super.menuItemClicked();
    this.onClickItem.emit();
  }
}
